export default __webpack_public_path__ + "static/KEVIN-MARTINEZ-SOMOS-2-69c29e5d34b887a8711437ae283563aa.png";